<template>
  <v-dialog v-model="internalValue" :max-width="width" persistent>
    <v-card class="gd-card">
      <!-- HEADER -->
      <div v-if="title" class="gd-header pl-base-bg">
        <div class="gd-header-left">
          <div class="gd-header-icon">
            <v-icon color="#fff" size="20">{{ icon }}</v-icon>
          </div>
          <span class="gd-title">{{ title }}</span>
        </div>

        <v-btn icon small class="gd-close-btn" @click="close">
          <v-icon size="18" color="#fff">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- BODY -->
      <v-card-text class="pa-4 dialog-body">
        <slot />
      </v-card-text>

      <!-- FOOTER -->
      <v-card-actions class="dialog-actions">
        <v-spacer />

        <v-btn
          v-for="(button, index) in buttons"
          :key="index"
          :class="!button.color && !button.outlined && !button.textStyle ? 'gd-primary-btn' : null"
          :color="button.color"
          :outlined="button.outlined"
          :text="button.textStyle"
          :disabled="button.disabled"
          :loading="button.loading"
          @click="handleAction(button)"
        >
          {{ button.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GlobalDialog",
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: "" },
    icon: { type: String, default: "mdi-information-outline" },
    width: { type: [Number, String], default: 420 },
    buttons: { type: Array, default: () => [] },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.internalValue = false;
    },
    handleAction(button) {
      if (button.action && typeof button.action === "function") {
        button.action();
      }
    },
  },
};
</script>

<style scoped>
.gd-card {
  border-radius: 0;
  overflow: hidden;
}

/* HEADER */
.gd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
}

.gd-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gd-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gd-title {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.gd-close-btn {
  background: rgba(255, 255, 255, 0.16) !important;
}

/* BODY */
.dialog-body {
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.7);
}

/* FOOTER */
.dialog-actions {
  padding: 8px 16px 16px;
  justify-content: flex-end;
  gap: 8px;
}

.gd-primary-btn {
  background: var(--pl-base-bg-gradient) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
}
</style>
